import React from "react";
import { Link } from "react-router-dom";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";
import { getFormatedDateInString } from "helper/EventHelper/EventHelper";

const ReviewTab = ({
  connectStatus,
  ratingCount,
  reviewsList,
  ratingPercentArr,
  token,
}) => {
  const starCount = [1, 2, 3, 4, 5];
  const floatValue = parseFloat(ratingCount); // Parse the string as a floating-point number
  const intValue = Math.ceil(floatValue); // Round up to the nearest integer

  return (
    <div className="bg-white p-4">
      <div className="feedback_progress_outer d-flex mb-4 w-100 align-items-center">
        <div className="left_progress d-flex ">
          <div className="contnt_hdng">
            <h2 className="d-flex align-items-center gap-1 text-primary">
              {ratingCount}
              <span>({reviewsList.length})</span>
            </h2>

            <div className="course_rvw_row mt-1">
              <ul className="list_style_none d-flex align-items-center">
                {starCount.map((star, index) => (
                  <li
                    key={index}
                    className={index < intValue ? "active_star" : ""}
                  >
                    <Link to="#">
                      <span className="material-icons-outlined text-primary-gray fs-lg">
                        star
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* star rating bar */}
          <div className="progress_item">
            {ratingPercentArr.map((ratingBar, index) => {
              return (
                <div
                  className="progress_row d-flex align-items-center mb-2"
                  key={index}
                >
                  <h5 className="first_number fs-sm text-primary fw-bold">
                    <span>{ratingBar.ratingname} Star</span>
                  </h5>
                  <div
                    className="progress"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar"
                      style={{ width: `${ratingBar.ratingpercent}%` }}
                    ></div>
                  </div>
                  <h5 className="fs-sm text-primary">
                    {ratingBar.ratingpercent}%
                  </h5>
                </div>
              );
            })}
          </div>
        </div>

        {token && connectStatus && (
          <div className="right_rvw_btn">
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#feedback_modal"
              className="btn primary-btn"
            >
              Write a Review
            </Link>
          </div>
        )}
      </div>

      <div className="activity_rightItem pb-0">
        {reviewsList.map((reviewData, index) => {
          return (
            <div className="forum_row" key={index}>
              <div className="forum_cmntsRow  position-relative d-flex align-items-center justify-content-between">
                <div className="team_userOuter forum_usrOuter d-flex gap-2">
                  <div className="team_usr_pic rounded-circle overflow-hidden">
                    <img
                      src={
                        reviewData.userimage === ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + reviewData.userimage
                      }
                      alt=""
                    />
                  </div>
                  <div className="team_usrTxt">
                    <div className="d-flex align-items-start justify-content-between w-100">
                      <div className="name_left">
                        <h4 className="text-black fs-md fw-bold mb-1">
                          {reviewData.username}
                        </h4>
                        <h5 className="fs-sm text-black">
                          {getFormatedDateInString(reviewData.reviewdate)}{" "}
                          {reviewData.reviewtime}
                        </h5>

                        <div className="course_rvw_row mt-1">
                          <ul className="list_style_none d-flex align-items-center">
                            {starCount.map((star, index) => (
                              <li
                                key={index}
                                className={
                                  index < parseInt(reviewData.rating)
                                    ? "active_star"
                                    : ""
                                }
                              >
                                <Link to="#">
                                  <span className="material-icons-outlined text-primary-gray fs-lg">
                                    star
                                  </span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="forum_para mt-3">
                      <p>{reviewData.comment}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewTab;
